import { Link } from "react-router-dom";
import { LI, UL } from "../../../../../AbstractElements";
import { Href } from "../../../../../Constants/Constants";
import { useAppDispatch } from "../../../../../ReduxToolkit/Hooks";
import { addToCartData } from "../../../../../ReduxToolkit/Reducers/ECommerce/CartSlice";
import { HoverButtonsProp, ProductItemInterface } from "../../../../../Types/EcommerceType";

export const HoverButtons:React.FC<HoverButtonsProp> = ({ item, setDataId, setOpenModal }) => {
  const dispatch = useAppDispatch();
  const AddToCarts = (item: ProductItemInterface, quantity: number) => dispatch(addToCartData({ item, quantity }));
  const onClickHandle = (i: ProductItemInterface) => {
    setOpenModal(true);
    setDataId(i.id);
  };

  return (
    <div className="product-hover">
      <UL className="simple-list flex-row">
        <LI>
          <Link to={`${process.env.PUBLIC_URL}/applications/ecommerce/cart`} color="transparent" onClick={() => AddToCarts(item, 1)}>
            <i className="icon-shopping-cart"></i>
          </Link>
        </LI>
        <LI>
          <Link to={Href} color="transparent" onClick={() => onClickHandle(item)}>
            <i className="icon-eye"></i>
          </Link>
        </LI>
      </UL>
    </div>
  );
};
